import { useState } from "react";
import { useAuth, formatApiError } from "../context/AuthContext";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { PasswordInput } from "./PasswordInput";
import { Label } from "./ui/label";
import { toast } from "sonner";

export const ChangePasswordCard = ({ forced, onDone }) => {
  const { changePassword } = useAuth();
  const [cur, setCur] = useState("");
  const [np, setNp] = useState("");
  const [cf, setCf] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (np.length < 8) return toast.error("New password must be at least 8 characters");
    if (np !== cf) return toast.error("New password and confirmation do not match");
    setBusy(true);
    try {
      await changePassword(cur, np);
      toast.success("Password updated");
      onDone && onDone();
    } catch (e) {
      toast.error(formatApiError(e?.response?.data?.detail) || "Failed to update password");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-4" data-testid="change-password-card">
      {forced && <p className="text-sm text-muted-foreground">For security, please set your own password before continuing.</p>}
      <div className="space-y-2">
        <Label>Current Password</Label>
        <PasswordInput value={cur} onChange={(e) => setCur(e.target.value)} data-testid="cp-current" autoComplete="current-password" />
      </div>
      <div className="space-y-2">
        <Label>New Password</Label>
        <PasswordInput value={np} onChange={(e) => setNp(e.target.value)} data-testid="cp-new" autoComplete="new-password" />
        <p className="text-xs text-muted-foreground">At least 8 characters, different from your current password.</p>
      </div>
      <div className="space-y-2">
        <Label>Confirm New Password</Label>
        <PasswordInput value={cf} onChange={(e) => setCf(e.target.value)} data-testid="cp-confirm" autoComplete="new-password" />
      </div>
      <Button className="w-full" onClick={submit} disabled={busy || !cur || !np || !cf} data-testid="cp-submit">
        {busy ? "Updating…" : "Update Password"}
      </Button>
    </div>
  );
};
